module.exports = __webpack_public_path__ + "img/code-profile-details.a7ea8476.png";